import React from 'react';
import { ItemHeadAdminPermission } from '../ItemHeadAdminPermission';
import { ItemAdminPermission } from '../ItemAdminPermission';
import './TableAdminPermission.css';
import { size } from 'lodash';

export function TableAdminPermission(props) {
  const { adminPermissions, onReload } = props;

 // if (adminPermissions) {
    return (
      <>
        <div className='table-admin_permission'>
        <table>
          <ItemHeadAdminPermission />
  
        
          { size(adminPermissions) === 0?  <p>not results</p>:
            adminPermissions.map((adminPermission) => (
              <ItemAdminPermission 
                adminPermission={adminPermission}
                onReload={onReload}
                key={adminPermission.id} 
              />
            ))
          }
          
  
  
        </table>
      </div>
      </>
    )    
 // }
  
}
